import React from "react";
import PropTypes from "prop-types";

import FormItem from "components/FormItem/FormItem";
import Upload from "../Upload";

// accept ref: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept
const FormUpload = ({
  name,
  label,
  acceptTypes,
  fileSizeLimitInMb,
  labelButtonUpload,

  requiredErrorMessage,

  isDisabled,
  isMultiple,
  isDisplayCard,

  onChange,
  onFileUploadChange,

  tooltipMessage,
}) => {
  return (
    <FormItem
      name={name}
      label={label}
      requiredErrorMessage={requiredErrorMessage}
      tooltipMessage={tooltipMessage}
    >
      <Upload
        acceptTypes={acceptTypes}
        fileSizeLimitInMb={fileSizeLimitInMb}
        labelButtonUpload={labelButtonUpload}
        isDisabled={isDisabled}
        isMultiple={isMultiple}
        isDisplayCard={isDisplayCard}
        onChange={onChange}
        onFileUploadChange={onFileUploadChange}
      />
    </FormItem>
  );
};

FormUpload.propTypes = {
  name: PropTypes.array.isRequired,
  label: PropTypes.string,
  acceptTypes: PropTypes.array,
  fileSizeLimitInMb: PropTypes.number,
  labelButtonUpload: PropTypes.string,

  requiredErrorMessage: PropTypes.string,
  extraRules: PropTypes.array,

  isDisabled: PropTypes.bool,
  isMultiple: PropTypes.bool,
  isDisplayCard: PropTypes.bool,

  onChange: PropTypes.func,
  onFileUploadChange: PropTypes.func,

  tooltipMessage: PropTypes.string,
};

export default FormUpload;
